<template>
  <div class="tai-xiu-board-layout" :class="{ 'tai-xiu-board-layout--with-top': hasTop }">
    <div v-if="hasTop" class="tai-xiu-board-layout__top">
      <slot name="top" />
    </div>
    <div class="tai-xiu-board-layout__main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaiXiuBoardLayout',
  computed: {
    hasTop() {
      return Boolean(this.$slots.top);
    },
  },
};
</script>

<style lang="scss" scoped>
.tai-xiu-board-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  // v2.1: no card -- the video, its bar and the board sit straight on the
  // page, 10px in from the edges and 8 apart.
  width: calc(100% - 20px);
  max-width: min(440px, calc(100% - 20px));
  margin-right: auto;
  margin-left: auto;
  padding-top: 8px;
  box-sizing: border-box;
  border-radius: 0;
  /*
   * `clip`, not `hidden`: both round the corners, but `hidden` makes this a
   * scroll container, and the chip row's `position: sticky` then resolves
   * against it -- a box that never scrolls -- instead of the page's scroller.
   */
  overflow: clip;
  background: transparent;
}

.tai-xiu-board-layout__top,
.tai-xiu-board-layout__main {
  background: transparent;
}

.tai-xiu-board-layout__top {
  flex: 0 0 auto;
  min-width: 0;
  padding: 0;
}

.tai-xiu-board-layout__main {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 0 10px;
}

.tai-xiu-board-layout--with-top .tai-xiu-board-layout__main {
  margin-top: 8px;
}

.tai-xiu-board-layout__main ::v-deep .tai-xiu-board.fancy {
  width: 100%;
  max-width: none;
  min-height: 0;
  padding: 0;
  border-radius: 0;
  background: transparent;
  /*
   * Visible on both axes: `overflow-x: hidden` alone computes the other axis to
   * `auto`, which made this a scroll container and captured the sticky chip row.
   * The rows that can overflow sideways scroll themselves.
   */
  overflow: visible;
}

.tai-xiu-board-layout__main ::v-deep .tai-xiu-board.fancy.full {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
